module.exports = __webpack_public_path__ + "img/check.f3248579.svg";